import { Component, OnInit, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ContainerUseService } from '../../core/api/container-use.service';
import { ContainerUse } from '../../shared/models/container-use';
import { statusTone } from '../../shared/status-tone';
import { AppNavComponent } from '../../shared/app-nav.component';
import { BackButtonComponent } from '../../shared/back-button.component';
import { TranslatePipe } from '../../shared/translate.pipe';
import { StatusLabelPipe } from '../../shared/status-label.pipe';

@Component({
  standalone: true,
  imports: [RouterLink, AppNavComponent, BackButtonComponent, TranslatePipe, StatusLabelPipe],
  template: `
        <app-nav></app-nav>
    <main class="page-shell">
      <header class="topbar">
        <app-back></app-back>
        <h1>{{ 'container.title' | t }}</h1>
      </header>
      @if (loading()) {
        <div class="skeleton-list">
          @for (i of [1,2,3,4,5,6]; track i) { <div class="skeleton-row"></div> }
        </div>
      }
      @if (error()) { <p class="error notice">{{ error() | t }}</p> }
      <section class="list">
        @for (item of items(); track item.ContainerCode) {
          <div class="list-row static" [class]="'tone-' + tone(item.StatusName)">
            <div>
              <strong>{{ item.ContainerCode }}</strong>
              <span>{{ item.CargoTypeName || '' }}</span>
            </div>
            <div class="row-meta">
              <span class="status-pill" [class]="tone(item.StatusName)">{{ item.StatusName | statusLabel }}</span>
            </div>
          </div>
        } @empty { @if (!loading() && !error()) {
          <div class="empty-state">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M4 7h16v13H4z"/><path d="M4 7l3-4h10l3 4"/><path d="M9 11h6"/></svg>
            <span>{{ 'container.empty' | t }}</span>
          </div>
        } }
      </section>
    </main>
  `
})
export class ContainerUsePage implements OnInit {
  readonly items = signal<ContainerUse[]>([]);
  readonly loading = signal(true);
  readonly error = signal('');
  constructor(private readonly api: ContainerUseService) {}
  ngOnInit(): void {
    this.api.search({ Page: 1, PageSize: 50 }).subscribe({
      next: items => { this.items.set(items); this.loading.set(false); },
      error: err => { this.error.set(err?.error?.Message ?? err?.error?.message ?? 'container.loadError'); this.loading.set(false); }
    });
  }
  tone(status?: string | null): string { return statusTone(status); }
}
